import React, { useEffect, useState } from 'react';
import { Button, Divider, message, Result, Row } from 'antd';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import CustomAddNewPageContent from '../../../components/Content/CustomAddNewPageContent';
import General from './tabs/General';
import {
  getBeaconsAction,
  getBeaconByIdAction,
  getBeaconCompleteByIdAction,
  saveBeaconAction,
} from '../../../actions/AppCms/BeaconActions';
import { history } from '../../../utils/history';
import Authorized from '../../../components/Authorization/Authorized';
import AuditTrail from '../../../components/AuditTrail/AuditTrail';

const AssignBeacon = ({ match, form }) => {
  const dispatch = useDispatch();

  const [finished, setFinished] = useState(false);
  // const [exportButtonClicked, setExportButtonClicked] = useState(false);
  const [itemUniqueId, setItemUniqueId] = useState(0);
  const [itemId, setItemId] = useState(0);
  const [selectedBeacon, setSelectedBeacon] = useState({});

  const { beacons, beaconFilterParams } = useSelector(store => ({
    beacons: store.beaconReducer.beacons,
    beaconFilterParams: store.filterReducer.beaconFilterParams,
  }));

  useEffect(() => {
    const { id, uniqueId } = match.params;
    setItemUniqueId(uniqueId);
    setItemId(id);

    if (!beacons || beacons.length === 0) {
      dispatch(getBeaconsAction(beaconFilterParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { uniqueId } = match.params;
    if (uniqueId !== undefined && beacons && beacons.length > 0) {
      setSelectedBeacon(beacons.find(item => item.uniqueId === uniqueId) || {});
    }
  }, [beacons, match.params]);

  const handleGoBeacons = () => {
    history.push('/beacons');
  };

  const handleSubmit = e => {
    e.preventDefault();

    form.validateFieldsAndScroll((err, fieldsValue) => {
      if (!err) {
        const values = {
          uniqueId: selectedBeacon.uniqueId || match.params.uniqueId,
          mac: selectedBeacon.mac || fieldsValue.mac,
          pointOfInterestId: fieldsValue.pointOfInterestId,
          groupId: fieldsValue.groupId,
        };

        if (!values.uniqueId || !values.mac) {
          message.error('Beacon data is not loaded yet. Please try again.');
          return;
        }

        dispatch(saveBeaconAction(values)).then(() => {
          message.success('Beacon assigned!');
          setFinished(true);
        });
      }
    });
  };

  // const exportCallBack = () => {
  //   setExportButtonClicked(false);
  // };

  // async function handleExport() {
  //   const { id } = match.params;

  //   dispatch(getBeaconCompleteByIdAction(id)).then(() => {
  //     message.success('Beacon saved!');
  //     setExportButtonClicked(true);
  //   });
  // }

  // const getReportData = (beaconData, lang) => {
  //   const result =
  //     beaconData &&
  //     beaconData.data.content.filter(obj => {
  //       return obj.language === lang;
  //     });
  //   return result ? result[0] : result;
  // };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
      md: { span: 16 },
      lg: { span: 12 },
    },
  };

  return (
    (<CustomAddNewPageContent
      title="Assign Beacon"
      subTitle="Beacon"
      // exportButton={
      //   <Button type="primary" onClick={() => handleExport()}>
      //     Export PDF
      //   </Button>
      // }
    >
      {!finished && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Form {...formItemLayout} onSubmit={handleSubmit}>
          {/* <Card
              title="GENERAL"
              bordered={false}
              extra={
                <Authorized asset="appcms" operation="write">
                  <Button type="primary" htmlType="submit">
                    Save
                  </Button>
                </Authorized>
              }
            > */}
          <General
            key={selectedBeacon.uniqueId || 'empty'}
            form={form}
            reportData={selectedBeacon}
          />
          {/* </Card> */}
          <Authorized asset="appcms" operation="write">
            <Divider />
            <Row type="flex" justify="center">
              <Button type="primary" htmlType="submit">
                Save
              </Button>
            </Row>
            <Divider />
            <AuditTrail objectId={itemId} objectType="beacon" />
          </Authorized>
        </Form>)
      )}
      {finished && (
        <Result
          status="success"
          title="Successfully saved beacon!"
          // subTitle="Order number: 2017182818828182881 Cloud server configuration takes 1-5 minutes, please wait."
          extra={[
            <Button type="primary" key="console" onClick={handleGoBeacons}>
              Go to Beacons
            </Button>,
          ]}
        />
      )}
      {/* {exportButtonClicked && (
          <BeaconPdf
            report={beaconComplete}
            callback={exportCallBack}
          />
        )} */}
    </CustomAddNewPageContent>)
  );
};

AssignBeacon.propTypes = {
  form: PropTypes.object,
  saveBeaconAction: PropTypes.func,
  getBeaconByIdAction: PropTypes.func,
  match: PropTypes.object,
  beacon: PropTypes.object,
  beaconComplete: PropTypes.object,
  getBeaconCompleteByIdAction: PropTypes.func,
};

const WrappedBeaconForm = Form.create({
  name: 'WrappedBeacon',
})(AssignBeacon);

function mapStateToProps({ beaconReducer }) {
  const { beacon, beaconComplete } = beaconReducer;
  return { beacon, beaconComplete };
}

const WrappedAssignBeacon = connect(mapStateToProps, {
  saveBeaconAction,
  getBeaconByIdAction,
  getBeaconCompleteByIdAction,
})(WrappedBeaconForm);

export default WrappedAssignBeacon;